export type BrokerId = 'schwab' | 'ib';

export const BROKER_IDS: BrokerId[] = ['schwab', 'ib'];

export function isBrokerId(value: string | null | undefined): value is BrokerId {
  return value === 'schwab' || value === 'ib';
}

export interface BrokerAuthStatus {
  broker: BrokerId;
  connected: boolean;
  needsReauth: boolean;
  message: string | null;
  expiresAt?: string | null;
}

export const BROKER_LABELS: Record<BrokerId, string> = {
  schwab: 'Charles Schwab',
  ib: 'Interactive Brokers',
};
